import styled from "@emotion/styled";

const StyledFormInput = styled.div`
  position: relative;

  .eye {
    position: absolute;
    top: 13px;
    right: 20px;
    color: rgba(0, 59, 33, 1);

    border: 0;
    background: none;

    &:hover {
      cursor: pointer;
    }
  }

  &.compressed {
    .eye {
      top: 6px;
      right: 0px;
    }
  }

  &.mobile {
    .eye {
      top: 12px;
      right: 16px;
    }

    input {
      font-size: 14px;
      line-height: 18.2px;
    }
  }

  input,
  textarea,
  select {
    padding: 1em 8px 0.8em 8px;
    display: block;
    width: ${(props) => (props.size ? props.size : "100%")};
    border: none;
    border: 1px solid rgba(0, 0, 0, 0.32);
    border-radius: 16px;
    /* background: ${(props) => props.config?.themeLayout?.background}; */
    font-family: "Roboto";
    font-weight: 400;
    font-size: 18px;
    color: rgba(0, 59, 33, 1);

    &:focus {
      outline: none;
      border-color: #8c8c8c;
    }

    &:read-only ~ label,
    &:focus ~ label,
    &:valid ~ label,
    &:disabled ~ label {
      top: 0.1em;
      left: 0;
      padding: 0px 9px;

      span {
        font-size: 0.65em !important;
        color: #8c8c8c;
      }

      .label-show {
      }
    }

    &:read-only,
    &:disabled {
      opacity: 0.5;
    }
  }

  textarea {
    height: 8em;
  }

  label {
    color: #8c8c8c;
    position: absolute;
    pointer-events: none;
    left: 0.8em;
    top: ${(props) => (props.top ? props.top : "0.8em")};
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
    font-family: "Roboto";
    font-size: 18px;

    .label-bg {
      position: absolute;
      top: 9px;
      left: -2px;
      width: calc(100% + 4px);
      height: 3px;
      /* background: ${(props) => props.config?.themeLayout?.background}; */
    }

    .label-show {
      position: absolute;
      z-index: 2;
    }

    .label-placeholder {
      opacity: 0;
    }
  }

  .error {
    display: inline-block;
    position: relative;
    padding-top: 2px;
    justify-content: start;
    color: #ff0f00;
    font-size: 12px;
    font-family: "Roboto";
  }

  div.append {
    font-family: "Roboto";
    font-size: 12px;
  }

  &.compressed {
    input,
    textarea,
    select {
      padding: 0.5em;
      font-size: 0.9em;
      /* padding-right:2.5em; */

      &:focus ~ label,
      &:valid ~ label,
      &:disabled ~ label {
        top: -8px;
        font-size: 0.7em;
      }
    }

    select {
      padding-right: 2.5em;
    }

    label {
      top: 0.6em;
      left: 0.55em;
      font-size: 0.9em;

      .label-bg {
        top: 7px;
      }
    }

    p.error {
      position: relative;
      font-size: 0.7em;
    }
  }

  &.hidden {
    display: none;
  }
`;

export default StyledFormInput;
